<template>
  <v-card v-if="reload" class="ma-0 px-1" width="100%" flat>
    <v-app-bar flat class="my-0 mb-2 py-1 px-4" dense height="30">
      <v-toolbar-title> {{ $t("customer&detail") }} </v-toolbar-title>
      <v-spacer />
      <v-checkbox
        v-model="status"
        class="mt-5 mx-3"
        :label="$t('active')"
        value="active"
      />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="goTo('customer')"
          >
            <v-icon color="teal" style="font-size: 22px"> mdi-plus-box-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("newCustomer") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" icon small v-on="on" @click="goTo('customerList')">
            <v-icon color="primary" style="font-size: 22px">
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("customerList") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" icon small v-on="on" @click="$router.go(-1)">
            <v-icon color="primary" style="font-size: 22px"> mdi-arrow-left </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("back") }}</span>
      </v-tooltip>
    </v-app-bar>

    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />

    <v-form v-if="render" ref="form" v-model="valid">
      <v-tabs v-model="activeTab">
        <v-tab>{{ $t("public-information") }}</v-tab>
        <v-tab v-if="activeUser"> {{ $t("userInformation") }}&{{ $t("access") }} </v-tab>
        <v-tab>{{ $t("Integrator") }}</v-tab>
        <v-tab :disabled="!documentPermmission">
          {{ $t("documents") }}
        </v-tab>
        <v-tab v-if="activeUser && branchesItems != null">
          {{ $t("smses") }}
        </v-tab>
        <v-tab v-if="personnely">{{ $t("personnely") }}</v-tab>

        <v-tab-item>
          <v-container>
            <v-row class="pt-1 pa-0">
              <v-col cols="12" md="1">
                <v-row>
                  <v-col cols="12" :class="{ 'mb-6': $vuetify.breakpoint.mobile }">
                    <file-picker
                      ref="refFilePicker"
                      v-model="imagePicker"
                      :label="$t('uploadImage')"
                      :avatar="true"
                      :multiple="false"
                      extensions="image/png, image/gif, image/jpeg"
                      type-prop="personAvatar"
                      :val="imagePickerVal ? imagePickerVal : null"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="ps-5" md="11">
                <v-row>
                  <v-col cols="12" md="2">
                    <v-btn-toggle
                      v-model="personType"
                      mandatory
                      dense
                      class="d-flex"
                      style="width: 100%"
                    >
                      <v-btn
                        value="real"
                        height="35"
                        class="flex-grow-1"
                        style="color: #2b2b2b"
                      >
                        {{ $t("Individual") }}
                      </v-btn>
                      <v-btn
                        value="company"
                        height="35"
                        class="flex-grow-1"
                        style="color: #2b2b2b"
                      >
                        {{ $t("legal") }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                  <v-col cols="12" md="10" class="pa-0 pt-2">
                    <v-container class="pa-0 m-0 d-flex ps-5 gap-3">
                      <v-checkbox
                        v-model="lead"
                        class="mt-0"
                        :label="$t('lead')"
                        value="active"
                        :disabled="personel == 'active' ? true : false"
                      />
                      <!-- add check personnel check box  --->
                      <v-checkbox
                        v-if="salaryPermission"
                        v-model="personnely"
                        class="mt-0"
                        :label="$t('personnely')"
                        value="active"
                        :disabled="lead == 'active' ? true : false"
                      />
                      <v-checkbox
                        v-model="personel"
                        class="mt-0"
                        :label="$t('user')"
                        value="active"
                        :disabled="lead == 'active' ? true : false"
                      />
                      <span v-if="learningPermission" class="d-flex">
                        <v-checkbox
                          v-model="student"
                          class="mt-0"
                          :label="$t('student', { name: $store.state.studentLabel })"
                          value="active"
                          :disabled="lead == 'active' ? true : false"
                        />
                        <v-checkbox
                          v-model="teacher"
                          class="mt-0 ms-2"
                          :label="$t('teacher')"
                          value="active"
                          :disabled="lead == 'active' ? true : false"
                        />
                      </span>
                      <span v-if="commissionPermission" class="d-flex">
                        <v-checkbox
                          v-model="visitor"
                          class="mt-0 ms-2"
                          :label="$t('visitor')"
                          value="active"
                          :disabled="lead == 'active' ? true : false"
                        />
                      </span>
                      <span v-if="investorPermission" class="d-flex">
                        <v-checkbox
                          v-model="investor"
                          class="mt-0 ms-2"
                          :label="$t('investor')"
                          value="active"
                          :disabled="lead == 'active' ? true : false"
                        />
                      </span>
                      <span v-if="translationPermission" class="d-flex">
                        <v-checkbox
                          v-model="translator"
                          class="mt-0"
                          :label="$t('translator')"
                          value="active"
                          :disabled="lead == 'active' ? true : false"
                        />
                      </span>
                    </v-container>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col v-if="personType === 'real'" cols="12" md="2">
                    <v-btn-toggle
                      v-model="gender"
                      mandatory
                      dense
                      class="d-flex"
                      style="width: 100%"
                    >
                      <v-btn
                        value="man"
                        height="35"
                        class="flex-grow-1"
                        style="color: #2b2b2b"
                      >
                        {{ $t("man") }}
                      </v-btn>
                      <v-btn
                        value="woman"
                        height="35"
                        class="flex-grow-1"
                        style="color: #2b2b2b"
                      >
                        {{ $t("woman") }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="firstname"
                      :label="$t('name')"
                      :rules="[
                        (v) => !!v || $t('is-required'),
                        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                      ]"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col v-show="gender !== 'company'" cols="12" md="2">
                    <v-text-field
                      v-model="lastname"
                      :label="$t('last-name')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="nationalCode"
                      :label="$t('national-code')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="mobile"
                      :label="$t('mobile')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-expansion-panels v-model="panel" multiple class="mt-8">
              <v-expansion-panel>
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t("otherCantactInfo") }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t("email") }} , {{ $t("phone") }} , {{ $t("address") }} , ...
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mb-2">
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="email"
                        :label="$t('email')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="phone"
                        :label="$t('phone')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mb-2">
                    <v-col cols="12" md="2">
                      <aicomplete
                        ref="refCountry"
                        v-model="country"
                        title="country"
                        type="country"
                        :val="country"
                        :new-btn="true"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <aicomplete
                        ref="refState"
                        v-model="state"
                        title="state"
                        type="state"
                        :val="state"
                        :new-btn="true"
                        :data="JSON.stringify({ parent: country ? country.id : null })"
                        :parent="country ? country.id : null"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <aicomplete
                        ref="refCity"
                        v-model="city"
                        title="city"
                        type="city"
                        :val="city"
                        :new-btn="true"
                        :data="JSON.stringify({ parent: country ? country.id : null })"
                        :parent="state ? state.id : null"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mb-2">
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="address"
                        outlined
                        clearable
                        dense
                        :label="$t('address')"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon> mdi-map-marker </v-icon>
                          <!--                    <div class="mt-1">-->
                          <!--                      {{(country ? country.name : '')}}-->
                          <!--                      {{(state ? ' - ' + state.name : '')}}-->
                          <!--                      {{(city ? ' - ' + city.name + ' - ' : '')}}-->
                          <!--                    </div>-->
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="postalCode"
                        :label="$t('postal-code')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t("grouping,tags") }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t("tag") }} , {{ $t("category") }} , ...
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mb-2">
                    <v-col cols="12" md="3">
                      <aicomplete
                        ref="refCategory"
                        v-model="category"
                        title="category"
                        type="accountCategory"
                        :val="category"
                        :new-btn="true"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <tag v-model="tag" :solo="false" :input="tag" />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t("otherIdentityInformation") }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t("birthDate") }} , {{ $t("financial-code") }} , ...
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content eager>
                  <v-row class="mb-2">
                    <v-col cols="12" md="2" class="mb-2">
                      <v-text-field
                        ref="refBusinessName"
                        v-model="businessName"
                        :label="$t('business-name')"
                        outlined
                        clearable
                        dense
                      />
                      <!-- :rules="[personnelyConditionRule]" -->
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <v-text-field
                        ref="refFinancialCode"
                        v-model="financialCode"
                        :label="$t('financial-code')"
                        outlined
                        clearable
                        dense
                      />
                      <!-- :rules="[(v) => !!v || $t('is-required')]" -->
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="customerBranch"
                        :label="$t('branch-name')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="customerTaxCodeBranch"
                        :label="$t('branch-tax-code')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <template>
                        <v-text-field
                          ref="refBirthDate"
                          id="date"
                          v-model="birthDate"
                          :label="$t('birthDate')"
                          single-line
                          clear-icon="flaticon2-close-cross"
                          outlined
                          dense
                          clearable
                          :rules="[personnelyConditionRule]"
                        />

                        <date-picker
                          v-model="birthDate"
                          element="date"
                          auto-submit
                          :color="
                            this.$vuetify.theme.themes[
                              this.$vuetify.theme.isDark ? 'dark' : 'light'
                            ].primary
                          "
                        />
                      </template>
                    </v-col>

                    <v-col cols="12" md="2" class="mb-2">
                      <aicomplete
                        ref="refStatePlaceofBirth"
                        v-model="statePlaceofBirth"
                        title="statePlaceofBirth"
                        type="state"
                        :val="statePlaceofBirth"
                        :new-btn="true"
                        :data="JSON.stringify({ parent: country ? country.id : null })"
                        :parent="country ? country.id : null"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <aicomplete
                        ref="refCityPlaceofBirth"
                        v-model="cityPlaceofBirth"
                        title="cityPlaceofBirth"
                        type="city"
                        :val="cityPlaceofBirth"
                        :new-btn="true"
                        :data="JSON.stringify({ parent: country ? country.id : null })"
                        :parent="state ? state.id : null"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <v-text-field
                        ref="refFathersName"
                        v-model="fathersName"
                        :label="$t('fathersName')"
                        outlined
                        clearable
                        dense
                        :rules="[personnelyConditionRule]"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <v-text-field
                        ref="refBirthCertificateNumber"
                        v-model="BirthCertificateNumber"
                        :label="$t('Birth Certificate Number')"
                        outlined
                        clearable
                        dense
                        :rules="[personnelyConditionRule]"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <template>
                        <v-text-field
                          ref="refDateOfBirthCertificate"
                          id="dateCertificate"
                          v-model="dateOfBirthCertificate"
                          :label="$t('dateOfBirthCertificate')"
                          single-line
                          clear-icon="flaticon2-close-cross"
                          outlined
                          dense
                          clearable
                          :rules="[personnelyConditionRule]"
                        />

                        <date-picker
                          v-model="dateOfBirthCertificate"
                          element="dateCertificate"
                          auto-submit
                          :color="
                            this.$vuetify.theme.themes[
                              this.$vuetify.theme.isDark ? 'dark' : 'light'
                            ].primary
                          "
                        />
                      </template>
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <aicomplete
                        ref="refStatePlaceOfBirthCertificate"
                        v-model="statePlaceOfBirthCertificate"
                        title="statePlaceOfBirthCertificate"
                        type="state"
                        :val="statePlaceOfBirthCertificate"
                        :new-btn="true"
                        :data="JSON.stringify({ parent: country ? country.id : null })"
                        :parent="country ? country.id : null"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <aicomplete
                        ref="refCityPlaceOfBirthCertificate"
                        v-model="cityPlaceOfBirthCertificate"
                        title="cityPlaceOfBirthCertificate"
                        type="city"
                        :val="cityPlaceOfBirthCertificate"
                        :new-btn="true"
                        :data="JSON.stringify({ parent: country ? country.id : null })"
                        :parent="state ? state.id : null"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <FlexibleAutocomplete
                        v-model="education_field"
                        title="certificate"
                        type="education_field"
                        :multiple="false"
                        :currency="currencyId"
                        :fetchData="fetchApi"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <FlexibleAutocomplete
                        v-model="magor"
                        title="magor"
                        type="magor"
                        :multiple="false"
                        :currency="currencyId"
                        :fetchData="fetchApi"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <v-text-field
                        v-model="childCount"
                        :label="$t('childCount')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="d-flex">
                      <v-checkbox
                        v-model="married"
                        class="mt-0"
                        :label="$t('married')"
                        :disabled="lead == 'active' ? true : false"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel v-show="$store.state.isMainYear">
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t("financialInformation") }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t("initialRemainingAndFinancialStatus") }}
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mb-2">
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="nature_initial_price"
                        :label="$t('natureAccount')"
                        :items="natureItems"
                        height="30"
                        dense
                        outlined
                        :disabled="!initialCheck"
                        item-value="value"
                        item-text="text"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <money
                        v-model="initial_price"
                        :label="$t('initialPrice')"
                        :dense="true"
                        :outlined="true"
                        :solo="false"
                        :clearable="true"
                        value-when-is-empty=""
                        :options="options"
                        :disabled="!initialCheck"
                        class="mb-3 dense"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel v-if="!isMobile && customFieldsPermission">
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t("customFields") }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t("customeFeildDescrible") }}
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <custom-fields
                    v-model="customFields"
                    :value="customFields"
                    typeProp="accountCustomFields"
                    class="px-4"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t("otherInformation") }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t("branch") }} , {{ $t("content") }} ,
                      {{ $t("attractionMethod") }} , {{ $t("Custom financial ID") }}...
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mb-2">
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="custom_code"
                        :label="$t('Custom financial ID')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <autocomplete
                        v-model="branch"
                        :title="$t('branch')"
                        type="branch"
                        :set-init="true"
                        :value="branch"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <autocomplete
                        v-model="attractionMethod"
                        :title="$t('attractionMethod')"
                        type="attractionMethod"
                        :value="attractionMethod"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <description v-model="content" :outlined="true" type="sell" />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
        </v-tab-item>
        <v-tab-item v-if="activeUser">
          <v-container>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="username"
                  :label="$t('username')"
                  outlined
                  clearable
                  dense
                  :disabled="personelStatus == 'active'"
                  @change="checkUser"
                />
              </v-col>
              <v-col v-if="!id" cols="12" md="3">
                <v-text-field
                  v-model="password"
                  :label="$t('password')"
                  outlined
                  clearable
                  dense
                  :disabled="isLoading || (!isLoading && isUserRepitetive != null)"
                  :loading="isLoading"
                />
              </v-col>
              <v-col cols="12" md="3">
                <autocomplete
                  ref="refRole"
                  v-model="role"
                  :title="$t('userRole')"
                  type="role"
                  :set-init="true"
                  :value="role"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-btn-toggle v-model="personnelType" mandatory dense>
                  <v-btn value="personnel" height="35" style="color: #2b2b2b">
                    {{ $t("personnel") }}
                  </v-btn>
                  <v-btn style="color: #2b2b2b" value="customer" height="35">
                    {{ $t("customer") }}
                  </v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" class="mb-2">
                <autocomplete
                  ref="refEntrepot"
                  v-model="entrepotAccess"
                  :title="$t('entrepotAccess')"
                  :multiple="true"
                  :value="entrepotAccess"
                  :data="JSON.stringify({ withoutAccess: 'active' })"
                  type="entrepot"
                  :disabled="!$store.state.access ? true : false"
                />
              </v-col>
              <v-col cols="12" md="3" class="mb-2">
                <aicomplete
                  v-model="branchAccess"
                  title="branch"
                  type="branch"
                  :val="branchAccess"
                  :multiple="true"
                  :new-btn="true"
                />
              </v-col>
              <v-col v-if="isSupport" cols="12" md="3" class="mb-2">
                <autocomplete
                  v-model="departmentAccess"
                  :title="$t('departmentAccess')"
                  :multiple="true"
                  :value="departmentAccess"
                  type="departments"
                  :disabled="!$store.state.access ? false : false"
                />
              </v-col>
              <v-col cols="12" md="3" class="mb-2">
                <autocomplete
                  v-model="bank"
                  :title="$t('bank') + '/' + $t('cash') + '/' + $t('petty')"
                  type="allBankCash"
                  :outlined="true"
                  :multiple="true"
                  :value="bank"
                />
              </v-col>
              <v-col md="1">
                <v-checkbox
                  v-model="admin"
                  class="mt-0"
                  :label="$t('admin')"
                  value="active"
                  :disabled="!$store.state.admin ? true : false"
                />
              </v-col>
              <v-col md="3">
                <v-checkbox
                  v-model="deactiveChangeSellPrice"
                  class="mt-0"
                  :label="$t('deactiveChangeSellPrice')"
                  value="active"
                  :disabled="!$store.state.access ? true : false"
                />
              </v-col>
              <v-col md="3">
                <v-checkbox
                  v-model="deactiveBranchAccess"
                  class="mt-0"
                  :label="$t('deactiveBranchAccess')"
                  value="active"
                  :disabled="!$store.state.access ? true : false"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  v-model="configs.showInStockProduct"
                  class="mt-0"
                  :label="$t('show only inStock product while searching')"
                  value="active"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container>
            <v-row class="pa-0 ma-0">
              <v-tabs vertical>
                <v-tab>
                  <v-icon class="me-3"> mdi-wordpress </v-icon>
                  {{ $t("woocommerce") }}
                </v-tab>
                <v-tab align="right">
                  <v-icon class="me-3"> mdi-shopping-outline </v-icon>
                  {{ $t("digikala") }}
                </v-tab>
                <v-tab align="right">
                  <v-icon class="me-3"> mdi-web </v-icon>
                  {{ $t("portal") }}
                </v-tab>
                <v-tab align="right">
                  <img width="20" class="me-4" src="@/assets/sazito.png" />
                  {{ $t("sazito") }}
                </v-tab>
                <v-tab align="right">
                  <img
                    width="20"
                    class="me-4"
                    src="@/assets/integrators/logo-magnet.png"
                  />
                  {{ $t("magnet") }}
                </v-tab>
                <v-tab align="right">
                  <img width="20" class="me-4" src="@/assets/webzi.png" />
                  {{ $t("webzi") }}
                </v-tab>
                <v-tab-item>
                  <v-container>
                    <v-row class="mx-0">
                      <v-col cols="6" class="px-0">
                        <v-btn
                          color="primary"
                          class="mr-0"
                          outlined
                          :loading="isLoading"
                          @click="addWoocommerceIdItems"
                        >
                          {{ $t("addId") }}
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-for="(item, h) in woocommerceIdItems" :key="h">
                      <v-col cols="12" md="3" class="mb-0">
                        <autocomplete
                          v-model="item.woocommercePanelName"
                          :title="$t('woocommercePanelName')"
                          :value="item.woocommercePanelName"
                          type="woocommercePanelName"
                        />
                      </v-col>
                      <v-col cols="12" md="2" class="mb-0">
                        <v-text-field
                          v-model="item.woocommerceId"
                          :label="$t('woocommerceId')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col cols="12" md="3" class="mb-0">
                        <v-btn
                          color="pink"
                          small
                          outlined
                          height="32"
                          @click="removeWoocommerceId(item)"
                        >
                          <v-icon> mdi-trash-can-outline </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="digikalaId"
                          :label="$t('digikalaId')"
                          height="20"
                          dense
                          outlined
                          :disabled="true"
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="portalId"
                          :label="$t('portalId')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="sazitoId"
                          :label="$t('sazitoId')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="magnetId"
                          :label="$t('magnetId')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="webziId"
                          :label="$t('webziId')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-checkbox
                          v-model="webziSeller"
                          class="mt-1 mx-3"
                          :label="$t('webziSeller')"
                          value="active"
                        />
                      </v-col>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="webziSellerCommission"
                          :label="$t('webziSellerCommission')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
              </v-tabs>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-row class="mx-0 pt-2">
            <v-col cols="12" md="3" sm="3">
              <file-picker
                ref="refFilePickerDocument"
                v-model="attachments"
                :label="$t('addDocuments')"
                :multiple="true"
                type-prop="account"
                :val="id && attachments ? attachments : null"
              />
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item v-if="activeUser && branchesItems != null" class="pa-4">
          <v-expansion-panels v-model="panelBranch" class="branch-panel" multiple>
            <v-expansion-panel
              v-for="(branch, index) in branchesItems"
              :key="branch.id || index"
            >
              <v-expansion-panel-header>
                <v-container class="d-flex align-center gap-2 pa-0">
                  <v-icon size="15">mdi-source-branch</v-icon>
                  <v-card-text class="pa-0 text-body-1">{{ branch.name }}</v-card-text>
                </v-container>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container class="pa-0">
                  <v-treeview
                    v-model="branch.smsTree"
                    :items="treeItems"
                    item-key="id"
                    selectable
                    open-on-click
                    selected-color="primary"
                  >
                    <template v-slot:label="{ item }">
                      {{ item.name }}
                    </template>
                  </v-treeview>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-tab-item>
        <!-- personnely tab content --->
        <v-tab-item class="pa-4">
          <v-expansion-panels v-model="panelPersonnely" class="mt-8">
            <!-- Insurer info --->
            <v-expansion-panel>
              <v-expansion-panel-header style="font-size: 14px">
                <div>
                  <div>{{ $t("InsurerInformation") }}</div>
                  <div class="abr-subtitle mt-2">
                    {{ $t("InsurerName") }} , {{ $t("InsurerNumber") }} ,
                    {{ $t("Record") }} , ...
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mb-2">
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="insurance_job_position"
                      title="InsurerRole"
                      type="insurance_job_position"
                      :multiple="false"
                      :currency="currencyId"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="insurance_type"
                      title="InsurerType"
                      type="insurance_type"
                      :multiple="false"
                      :currency="currencyId"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="InsurerName"
                      :label="$t('InsurerName')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="InsurerNumber"
                      :label="$t('InsurerNumber')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="InsurerRecordToMonth"
                      :label="$t('InsurerRecordToMonth')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- work info --->
            <v-expansion-panel>
              <v-expansion-panel-header style="font-size: 14px">
                <div>
                  <div>{{ $t("workInformation") }}</div>
                  <div class="abr-subtitle mt-2">
                    {{ $t("personnelCode") }} , {{ $t("workshop") }} ,{{
                      $t("jobPosition")
                    }}
                    , ...
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mb-2">
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="personnelCode"
                      :label="$t('personnelCode')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="workshop"
                      title="workshop"
                      type="WorkshopType"
                      :multiple="false"
                      :currency="currencyId"
                      :fetchData="fetchWorkshopApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="finance_job_position"
                      title="AssetsRole"
                      type="finance_job_position"
                      :multiple="false"
                      :currency="currencyId"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <template>
                      <v-text-field
                        id="startToWork"
                        v-model="startToWork"
                        :label="$t('startToWork')"
                        single-line
                        clear-icon="flaticon2-close-cross"
                        outlined
                        dense
                        clearable
                      />

                      <date-picker
                        v-model="startToWork"
                        element="startToWork"
                        auto-submit
                        :color="
                          this.$vuetify.theme.themes[
                            this.$vuetify.theme.isDark ? 'dark' : 'light'
                          ].primary
                        "
                      />
                    </template>
                  </v-col>
                  <v-col cols="12" md="2">
                    <template>
                      <v-text-field
                        id="EndToWork"
                        v-model="EndToWork"
                        :label="$t('EndToWork')"
                        single-line
                        clear-icon="flaticon2-close-cross"
                        outlined
                        dense
                        clearable
                      />

                      <date-picker
                        v-model="EndToWork"
                        element="EndToWork"
                        auto-submit
                        :color="
                          this.$vuetify.theme.themes[
                            this.$vuetify.theme.isDark ? 'dark' : 'light'
                          ].primary
                        "
                      />
                    </template>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="bankName"
                      :label="$t('bank-name')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="SalaryAccountNumber"
                      :label="$t('SalaryAccountNumber')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="type_of_employment"
                      title="employmentType"
                      :currency="currencyId"
                      type="type_of_employment"
                      :multiple="false"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="type_of_contract"
                      title="contractType"
                      type="type_of_contract"
                      :multiple="false"
                      :currency="currencyId"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- Service info --->
            <v-expansion-panel>
              <v-expansion-panel-header style="font-size: 14px">
                <div>
                  <div>{{ $t("Serviceinformation") }}</div>
                  <div class="abr-subtitle mt-2">
                    {{ $t("ServiceStatus") }} , {{ $t("jobCategory") }} ,{{
                      $t("ServicePlace")
                    }},...
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mb-2">
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="soldier_status"
                      title="Military Service Status"
                      type="soldier_status"
                      :currency="currencyId"
                      :multiple="false"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="job_field"
                      title="jobCategory"
                      type="job_field"
                      :multiple="false"
                      :currency="currencyId"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="ServicePlace"
                      :label="$t('ServicePlace')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="soldier_location_type"
                      title="ServicePlaceStatus"
                      type="soldier_location_type"
                      :multiple="false"
                      :currency="currencyId"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="exemption_type"
                      title="ExemptType"
                      type="exemption_type"
                      :currency="currencyId"
                      :multiple="false"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-tab-item>
      </v-tabs>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col cols="6" class="px-1">
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t("submit") }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t("submit") }}
            </v-btn>
          </v-col>
          <v-col cols="6" class="px-2"> </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import Description from "../../components/general/description/Description";
import aicomplete from "../../components/general/AIcomplete/index";
import General from "../../../../Mixins/general";
import filePicker from "../../components/general/filePicker/index";
import customFields from "../../components/general/customFields/index.vue";
import FlexibleAutocomplete from "../../components/general/patial/FlexibleAutocomplete.vue";

export default {
  name: "Customer",
  components: {
    Tag: () => import("../../components/general/Tag/tag"),
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    FlexibleAutocomplete,
    Description,
    customFields,
    filePicker,
    aicomplete,
  },
  mixins: [General],
  props: ["idProp", "returnObject"],
  data: () => ({
    SMSBRANCH: null,
    activeTab: null,
    webziSeller: null,
    webziSellerCommission: null,
    investorSellPercent: null,
    investorReturnSellPercent: null,
    visitorReturnSellPercent: null,
    panel: [5],
    panelPersonnely: null,
    personnelType: null,
    departmentAccess: null,
    customFields: null,
    attachments: null,
    deactiveBranchAccess: null,
    visitorSellPercent: null,
    reload: true,
    valid: true,
    gender: "man",
    showPassword: false,
    deactiveChangeSellPrice: false,
    branchAccess: null,
    imagePicker: null,
    imagePickerVal: null,
    portalId: null,
    student: null,
    teacher: null,
    investor: null,
    visitor: null,
    translator: null,
    personnel: null,
    woocommerceId: null,
    woocommerceIdItems: [],
    sazitoId: null,
    magnetId: null,
    webziId: null,
    digikalaId: null,
    role: null,
    admin: null,
    plan: null,
    category: null,
    entrepotAccess: null,
    initialCheck: true,
    username: null,
    avatar: null,
    password: null,
    tag: null,
    type: null,
    attractionMethod: null,
    lead: null,
    mobile: null,
    personel: null,
    status: "active",
    nationalCode: null,
    content: null,
    firstname: null,
    birthDate: null,
    lastname: null,
    postalCode: null,
    currency: null,
    businessName: null,
    //add
    statePlaceofBirth: null,
    cityPlaceofBirth: null,
    fathersName: null,
    BirthCertificateNumber: null,
    dateOfBirthCertificate: null,
    statePlaceOfBirthCertificate: null,
    cityPlaceOfBirthCertificate: null,
    education_field: null,
    childCount: null,
    insurance_job_position: null,
    insurance_type: null,
    InsurerName: null,
    InsurerNumber: null,
    InsurerRecordToMonth: null,
    personnelCode: null,
    workshop: null,
    finance_job_position: null,
    startToWork: null,
    EndToWork: null,
    bankName: null,
    SalaryAccountNumber: null,
    type_of_employment: null,
    type_of_contract: null,
    soldier_status: null,
    job_field: null,
    ServicePlace: null,
    soldier_location_type: null,
    exemption_type: null,
    magor: null,
    married: false,
    hrm_id: null,
    personnely: false,
    currencyId: "",
    //
    financialCode: null,
    phone: null,
    render: true,
    accountCategory: null,
    isLoading: false,
    country: null,
    state: null,
    stateWatch: false,
    countWoocommercepanel: 1,
    city: null,
    cityWatch: false,
    email: null,
    id: null,
    address: null,
    nature_initial_price: null,
    natureItems: null,
    initial_price: null,
    bank: null,
    /* userFinancialAccess: {
        bank_cash: {
          id: []
        }
      }, */
    options: {
      locale: "en-US",
      prefix: "",
      suffix: " ",
      precision: 0,
    },
    custom_code: null,
    panelBranch: null,
    optionsApi: {
      page: 1,
      itemsPerPage: 500,
    },
    branchesItems: null,
    smsTree: [],
    treeItems: null,
    isUserRepitetive: null,
    userFullName: null,
    customerBranch: null,
    customerTaxCodeBranch: null,
    configs: {
      showInStockProduct: null,
    },
    personelStatus: null,
  }),
  computed: {
    personType: {
      get() {
        return this.gender === "company" ? "company" : "real";
      },
      set(val) {
        if (val === "company") {
          this.gender = "company";
        } else if (this.gender === "company") {
          this.gender = "man";
        }
      },
    },
    personnelyConditionRule() {
      return (v) => {
        if (this.personnely === "active") {
          return !!v || this.$t("is-required");
        }
        return true;
      };
    },
    personnelyTabIndex() {
      if (!this.personnely) return null;
      let index = 1;
      if (this.activeUser) index++;
      index++;
      index++;
      if (this.activeUser && this.branchesItems != null) index++;
      return index;
    },
    isSupport() {
      try {
        const token = JSON.parse(localStorage.getItem("token") || "{}");
        return (
          Number(
            token &&
              token.init &&
              token.init.appBarsOpacity &&
              token.init.appBarsOpacity.abr
          ) === 83
        );
      } catch (e) {
        return false;
      }
    },
    activeUser() {
      var active = false;
      if (
        this.$store.state.permissions &&
        this.$store.state.permissions.includes("usersList") &&
        (this.student === "active" ||
          this.teacher === "active" ||
          this.translator === "active" ||
          this.personel)
      ) {
        active = true;
      }
      return active;
    },
  },
  watch: {
    personnelStatus: {
      handler(val) {
        if (val == "active") {
          this.personel = "active";
        }
      },
      deep: true,
      immediate: true,
    },

    activeTab(val) {
      if (val) {
        if (val == 4) {
          if (this.SMSBRANCH != null && this.SMSBRANCH.length > 0) {
            const apiBranchItems = this.SMSBRANCH;
            this.branchesItems =
              apiBranchItems != null && apiBranchItems.length > 0
                ? (this.branchesItems = this.branchesItems?.map((branch) => {
                    const match = apiBranchItems.find((b) => b.id == branch.id);
                    return {
                      ...branch,
                      smsTree: match ? match.smsTree : [],
                    };
                  }))
                : this.branchesItems;
          }
        }
      }
    },
    idProp() {
      this.render = true;
      if (this.idProp != null) {
        this.id = this.idProp;
        this.show();
        this.render = false;
      } else {
        this.render = false;
      }
    },
    initial_price(val) {
      if (val && parseFloat(val) > 0 && !this.nature) {
        this.nature = "debtor";
      }
    },
    avatar() {},
    branchesItems: {
      handler(newValue) {
        const simplified = newValue?.map((b) => ({
          id: b.id,
          name: b.name,
          smsTree: b.smsTree,
        }));
        if (JSON.stringify(this.branchesItems) !== JSON.stringify(simplified)) {
          this.branchesItems = simplified;
        }
      },
      deep: true,
    },
  },
  beforeMount() {
    if (this.$route.params.id != null) {
      this.id = this.$route.params.id;
      this.show();
      this.render = false;
    }
    if (this.idProp != null) {
      this.id = this.idProp;
      this.show();
      this.render = false;
    }
    if (!this.id && this.$route?.query?.fromPersonnel === "1") {
      this.personnely = "active";
    }
  },
  mounted() {
    if (!this.id) {
      this.username = null;
      this.password = null;
    }
    this.fetchItemsForSMS();
    this.fetchBranchesForSMS();

    if (this.woocommerceIdItems.length === 0) {
      this.addWoocommerceIdItems();
    }
    this.natureItems = [
      {
        value: "debtor",
        text: this.$t("debtor"),
      },
      {
        value: "creditor",
        text: this.$t("creditor"),
      },
    ];
  },
  methods: {
    openExpansionPanel(index) {
      const current = Array.isArray(this.panel) ? this.panel : [];
      if (!current.includes(index)) {
        this.panel = [...current, index];
      }
    },
    shouldOpenIdentityPanel() {
      const IDENTITY_PANEL_INDEX = 2;
      const personnelyIdentityFields = [
        "birthDate",
        "fathersName",
        "BirthCertificateNumber",
        "dateOfBirthCertificate",
      ];

      if (this.personnely === "active") {
        const hasMissingField = personnelyIdentityFields.some((field) => !this[field]);
        if (hasMissingField) {
          return IDENTITY_PANEL_INDEX;
        }
      }

      return null;
    },
    showWorkshopSnackbar() {
      this.snakbarText = this.$t("please-select-workshop");
      this.snakbarColor = "red";
      this.snakbar = true;
    },
    showComplateMainInfoSnackbar() {
      this.snakbarText = this.$t("complete-main-info-before-personnely");
      this.snakbarColor = "red";
      this.snakbar = true;
    },
    validateIdentityFields() {
      const fieldRefs = [
        "refBirthDate",
        "refFathersName",
        "refBirthCertificateNumber",
        "refDateOfBirthCertificate",
      ];

      fieldRefs.forEach((refName) => {
        const field = this.$refs[refName];
        if (field && typeof field.validate === "function") {
          field.validate(true);
        }
      });
    },
    runFormValidation() {
      this.validateIdentityFields();
      return this.$refs.form.validate();
    },
    fetchApi(payload) {
      var app = this;
      let params = {
        page: payload.page,
        key: payload.type,
        search: payload.search || "",
        options: JSON.stringify({
          itemsPerPage: 10,
        }),
        currency: app.currencyId,
      };
      return app.$axios
        .get(app.$endpoint + "hrm/get-config", { params })
        .then(function (response) {
          let list = response && response.data ? response.data : [];
          return {
            items: list,
            hasMore: list.length === 10,
          };
        });
    },
    fetchWorkshopApi(payload) {
      var app = this;
      let params = {
        page: payload.page,
        search: payload.search || "",
        options: JSON.stringify({
          itemsPerPage: 10,
        }),
        currency: app.currencyId,
      };
      return app.$axios
        .get(app.$endpoint + "workshop", { params })
        .then(function (response) {
          let list = response && response.data.data ? response.data.data : [];
          return {
            items: list,
            hasMore: list.length === 10,
          };
        });
    },
    checkUser() {
      var app = this;
      app.isLoading = true;
      app.$axios
        .get(this.$endpointI + "user/check-user-exist", {
          params: {
            mobile: app.username,
          },
        })
        .then((res) => {
          app.isUserRepitetive = res.data.data;
          if (app.isUserRepitetive != null) {
            app.snakbarText = app.$t("this user is repitetive");
            app.snakbarColor = "green";
            app.snakbar = true;
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addWoocommerceIdItems() {
      if (
        this.$store.state.allConfig &&
        this.$store.state.allConfig.countWoocommercePanel
      ) {
        this.countWoocommercepanel = this.$store.state.allConfig.countWoocommercePanel;
      }
      if (this.woocommerceIdItems.length < this.countWoocommercepanel) {
        var item = {
          woocommercePanelName: null,
          woocommerceId: null,
        };
        this.woocommerceIdItems.push(item);
      }
    },
    removeWoocommerceId(item) {
      var i = this.woocommerceIdItems.indexOf(item);
      this.woocommerceIdItems.splice(i, 1);
    },
    cancel() {
      if (!this.idProp && !this.returnObject) {
        // this.$store.commit("REMOVE_COMPONENTS", {
        //   path: this.$route.path,
        //   name: this.$route.name,
        //   query: { ...this.$route.query },
        //   params: { ...this.$route.params },
        // });
        if (this.lead === "active") {
          this.goTo("leadList");
        } else {
          if (this.personel === "active") {
            this.goTo("usersList");
          } else {
            this.goTo("customerList");
          }
        }
      } else {
        this.$emit("close");
      }
    },
    create() {
      var app = this;
      app.isLoading = true;

      const identityPanelIndex = this.shouldOpenIdentityPanel();
      if (identityPanelIndex !== null) {
        this.openExpansionPanel(identityPanelIndex);
      }

      this.$nextTick(() => {
        this.$nextTick(() => {
          const isFormValid = app.runFormValidation();
          const needsWorkshop = app.personnely === "active" && !app.workshop;

          if (
            this.personnelyTabIndex !== null &&
            this.activeTab === this.personnelyTabIndex
          ) {
            console.log(identityPanelIndex, "identityPanelIndex");
            if (identityPanelIndex !== null) {
              app.showComplateMainInfoSnackbar();
              app.isLoading = false;
              return;
            } else if (identityPanelIndex == null && needsWorkshop) {
              app.showWorkshopSnackbar();
              app.isLoading = false;
              return;
            }
          }
          if (!isFormValid) {
            if (needsWorkshop) {
              app.showWorkshopSnackbar();
            }
            app.isLoading = false;
            return;
          }

          if (needsWorkshop) {
            app.showWorkshopSnackbar();
            app.isLoading = false;
            return;
          }
          if (!app.firstname || !String(app.firstname).trim()) {
            app.activeTab = 0;
            app.snakbarText = `${app.$t("name")} ${app.$t("is-required")}`;
            app.snakbarColor = "red";
            app.snakbar = true;
            app.isLoading = false;
            return;
          }
          app.$axios
            .post(this.$endpoint + "customer", this.$data)
            .then((res) => {
              app.snakbarText = app.$t("registered");
              app.snakbarColor = "green";
              app.snakbar = true;
              if (app.imagePicker) {
                app.$refs.refFilePicker.create(res.data.data.id);
              }
              if (app.$refs.refFilePickerDocument !== undefined && app.attachments) {
                app.$refs.refFilePickerDocument.create(res.data.data.id);
              }
              app.$emit("input", res.data.data);
              app.clearForm();
              app.cancel();
            })
            .catch((err) => {
              this.isLoading = false;
              if (err.response && err.response.status === 409) {
                this.$store.commit("SET_PLAN_DIALOG", true);
              }
              this.serverErrorHandeler(err);
            })
            .finally(() => {
              this.isLoading = false;
            });
        });
      });
    },
    show() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "customer/" + this.id + "/edit", {
          params: {
            id: this.$route.params.id,
          },
        })
        .then((res) => {
          app.$nextTick(() => {
            res = res.data || null;
            app.hrm_id = res?.hrm_employee?.id || null;
            //true check box personnely
            if (app.hrm_id != null) {
              app.personnely = "active";
            } else {
              app.personnely = null;
            }
            //add showInStockProduct value checkbox
            if (res.configs) {
              app.configs.showInStockProduct = res.configs.value ?? null;
            }
            app.id = res.id;
            app.country = res.country;
            app.address = res.address;
            app.attachments = res.attachments;
            app.state = res.state;
            app.city = res.city;
            app.imagePicker = res.avatar;
            app.customFields = res.custom_fields;
            app.imagePickerVal = res.avatar;
            app.content = res.content;
            app.firstname = res.firstname;
            app.lastname = res.lastname;
            app.gender = res.gender;
            app.status = res.status;
            app.branch = res.meta ? res.meta.branch : null;
            app.personel = res.personel;
            app.personnelType = res.personnelType;
            app.departmentAccess =
              res.department_access.length != 0 ? res.department_access : null;
            app.category = res.category;
            app.lead = res.lead;
            app.email = res.email;
            app.phone = res.phone;
            app.mobile = res.mobile;
            app.plan = res.plan ? res.plan.plan : null;
            app.birthDate = res.birth_date;
            app.admin = res.admin;
            app.branchAccess = res.branchAccess.length != 0 ? res.branchAccess : null;
            app.entrepotAccess =
              res.entrepotAccess.length != 0 ? res.entrepotAccess : null;
            app.nationalCode = res.national_code;
            app.financialCode = res.financial_code;
            app.businessName = res.business_name;
            app.postalCode = res.postal_code;
            app.initialCheck = res.initialCheck;
            app.attractionMethod = res.attraction_method;
            app.nature_initial_price = res.nature_initial_price;
            app.initial_price = res.initial_price;
            app.bank =
              res.user_financial.length != 0
                ? res.user_financial.map((item) => item.bank)
                : null;
            app.role = res.role;
            app.username = res.username;
            app.custom_code = res.fin.custom_code;
            app.portalId = res.integrator.portalId;
            app.woocommerceIdItems = res.woocommerceIdItems;
            app.sazitoId = res.integrator.sazitoId;
            app.magnetId = res.integrator.magnetId;
            app.webziId = res.integrator.webziId;
            app.webziSeller = res.integrator.webziSeller;
            app.webziSellerCommission = res.integrator.webziSellerCommission;
            app.digikalaId = res.integrator.digikalaId;
            app.deactiveChangeSellPrice = res.integrator
              ? res.integrator.deactiveChangeSellPrice
              : null;
            app.deactiveBranchAccess = res.integrator
              ? res.integrator.deactiveBranchAccess
              : null;
            app.student = res.integrator ? res.integrator.student : null;
            app.teacher = res.integrator ? res.integrator.teacher : null;
            app.visitor = res.integrator ? res.integrator.visitor : null;
            app.investor = res.integrator ? res.integrator.investor : null;
            app.visitorSellPercent = res.integrator
              ? res.integrator.visitorSellPercent
              : null;
            app.visitorReturnSellPercent = res.integrator
              ? res.integrator.visitorReturnSellPercent
              : null;
            app.investorSellPercent = res.integrator
              ? res.integrator.investorSellPercent
              : null;
            app.investorReturnSellPercent = res.integrator
              ? res.integrator.investorReturnSellPercent
              : null;
            app.translator = res.integrator ? res.integrator.translator : null;
            app.SMSBRANCH = res.branchesItems;
            //add
            app.statePlaceofBirth = res?.hrm_employee?.state_place_birth || null;
            app.cityPlaceofBirth = res?.hrm_employee?.city_place_birth || null;
            app.fathersName = res?.hrm_employee?.fathers_name || null;
            app.BirthCertificateNumber =
              res?.hrm_employee?.birth_certificate_number || null;
            app.dateOfBirthCertificate =
              res?.hrm_employee?.date_of_birth_certificate || null;
            app.statePlaceOfBirthCertificate =
              res?.hrm_employee?.state_place_birth_certificate || null;
            app.cityPlaceOfBirthCertificate =
              res?.hrm_employee?.city_place_birth_certificate || null;
            app.education_field = res?.hrm_employee?.education_field || null;
            app.childCount = res?.hrm_employee?.child_count || null;
            app.insurance_job_position =
              res?.hrm_employee?.insurance_job_position || null;
            app.insurance_type = res?.hrm_employee?.insurance_type || null;
            app.InsurerName = res?.hrm_employee?.insurer_name || null;
            app.InsurerNumber = res?.hrm_employee?.insurer_number || null;
            app.InsurerRecordToMonth = res?.hrm_employee?.insurer_record_to_month || null;
            app.personnelCode = res?.hrm_employee?.personnel_code || null;
            app.workshop = res?.hrm_employee?.workshop || null;
            app.finance_job_position = res?.hrm_employee?.finance_job_position || null;
            app.startToWork = res?.hrm_employee?.start_to_work || null;
            app.EndToWork = res?.hrm_employee?.end_to_work || null;
            app.bankName = res?.hrm_employee?.bank_name || null;
            app.SalaryAccountNumber = res?.hrm_employee?.salary_account_number || null;
            app.type_of_employment = res?.hrm_employee?.type_of_employment || null;
            app.type_of_contract = res?.hrm_employee?.type_of_contract || null;
            app.soldier_status = res?.hrm_employee?.soldier_status || null;
            app.job_field = res?.hrm_employee?.job_field || null;
            app.ServicePlace = res?.hrm_employee?.service_place || null;
            app.soldier_location_type = res?.hrm_employee?.soldier_location_type || null;
            app.exemption_type = res?.hrm_employee?.exemption_type || null;
            app.magor = res?.hrm_employee?.magor || null;
            app.married = res?.hrm_employee?.married || false;
            app.customerBranch = res.meta?.customer_branch;
            app.customerTaxCodeBranch = res.meta?.customer_tax_code_branch;
            if (res.tags) {
              app.tag = res.tags;
              app.more = true;
            }
            app.render = true;
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    update() {
      var app = this;
      app.isLoading = true;
      app.$axios
        .put(this.$endpoint + "customer/" + this.id, this.$data)
        .then((res) => {
          res = res.data;
          app.$emit("close", app.$route);
          if (app.imagePicker) {
            app.$refs.refFilePicker.create(app.id);
          }
          if (app.$refs.refFilePickerDocument !== undefined) {
            app.$refs.refFilePickerDocument.create(app.id);
          }
          app.cancel();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          app.isLoading = false;
        });
    },
    clearForm() {
      this.valid = true;
      this.gender = "man";
      this.showPassword = false;
      this.attachments = null;
      this.role = null;
      this.category = null;
      this.username = null;
      this.avatar = null;
      this.password = null;
      this.tag = null;
      this.type = null;
      this.attractionMethod = null;
      this.lead = null;
      this.mobile = null;
      this.personel = null;
      this.status = "active";
      this.nationalCode = null;
      this.content = null;
      this.firstname = null;
      this.birthDate = null;
      this.lastname = null;
      this.postalCode = null;
      this.currency = null;
      this.businessName = null;
      this.financialCode = null;
      this.phone = null;
      this.accountCategory = null;
      this.isLoading = false;
      this.country = null;
      this.state = null;
      this.stateWatch = false;
      this.city = null;
      this.cityWatch = false;
      this.email = null;
      this.id = null;
      this.address = null;
      this.nature_initial_price = null;
      this.initial_price = null;
      this.custom_code = null;
      // this.treeItems = null
      // this.branchesItems = null
      // this.smsTree = null
    },
    fetchItemsForSMS() {
      var app = this;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            select: "getSmsTemplate",
          },
        })
        .then((res) => {
          const data = res.data;
          const keys = Object.keys(data);
          const treeItems = keys.map((moduleKey) => {
            return {
              id: moduleKey,
              module: moduleKey,
              name: this.$t(moduleKey),
              children: data[moduleKey].map((item) => ({
                id: item.id,
                name: this.$t(item.name),
              })),
            };
          });
          this.treeItems = treeItems;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(function () {});
    },
    fetchBranchesForSMS() {
      var app = this;
      app.$axios
        .get(app.$endpoint + "branch/list", {
          params: {
            type: "all",
            options: app.optionsApi,
          },
        })
        .then((res) => {
          const list = res.data.data || [];
          // Always include whole system item at top
          const wholeSystem = { id: 0, name: this.$t("whole-system"), smsTree: [] };
          if (list.length > 0) {
            this.branchesItems = [
              wholeSystem,
              ...list.map((branch) => ({
                ...branch,
                smsTree: [],
              })),
            ];
          } else {
            this.branchesItems = [wholeSystem];
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(function () {});
    },
  },
};
</script>

<style>
/* .col{
  height: 55px !important;
} */
/* 
::v-deep .v-label.v-label:not(.v-label--active) {
  top: 6px !important;
} */
.v-text-field--outlined .v-label {
  top: 6px;
}
.branch-panel .v-expansion-panel::before {
  box-shadow: none;
}
.v-card__text {
  width: auto;
}
.branch-panel .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #c0c0c026;
}
.branch-panel .v-expansion-panel {
  border: 1px solid silver;
  margin-bottom: 7px;
  border-radius: 4px;
}
.branch-panel .v-expansion-panel:not(:first-child)::after {
  border-top: none;
}
.branch-panel .v-expansion-panel-content__wrap {
  padding: 0;
}
.branch-panel .v-treeview-node__checkbox,
.branch-panel .v-treeview-node__content {
  margin-right: 0;
}
.branch-panel .v-treeview-node__content .v-treeview-node__prepend {
  display: none;
}
.branch-panel .v-treeview-node__root {
  gap: 0.25rem;
}
.branch-panel .v-treeview-node__root .v-icon.v-icon::after {
  background-color: transparent;
}
.v-application .accent--text {
  color: #0066ff !important;
  caret-color: #0066ff !important;
}
</style>
